/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Track } from './Track';
import {
    TrackFromJSON,
    TrackFromJSONTyped,
    TrackToJSON,
} from './Track';

/**
 * 
 * @export
 * @interface TrackFeedItem
 */
export interface TrackFeedItem {
    /**
     * 
     * @type {string}
     * @memberof TrackFeedItem
     */
    type: string;
    /**
     * 
     * @type {Track}
     * @memberof TrackFeedItem
     */
    item: Track;
}

/**
 * Check if a given object implements the TrackFeedItem interface.
 */
export function instanceOfTrackFeedItem(value: object): value is TrackFeedItem {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "item" in value && value["item"] !== undefined;

    return isInstance;
}

export function TrackFeedItemFromJSON(json: any): TrackFeedItem {
    return TrackFeedItemFromJSONTyped(json, false);
}

export function TrackFeedItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackFeedItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'item': TrackFromJSON(json['item']),
    };
}

export function TrackFeedItemToJSON(value?: TrackFeedItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'item': TrackToJSON(value.item),
    };
}

